type PhotoPreviewProps = {
  fileName: Nullable<string>;
  previewUrl: Nullable<string>;
};

export function PhotoPreview({ fileName, previewUrl }: PhotoPreviewProps) {
  if (!previewUrl || !fileName) return null;

  return (
    <div className="tw:rounded-lg tw:overflow-hidden tw:border tw:border-stroke-quaternary tw:bg-gray-50">
      <img
        alt={`Preview of ${fileName}`}
        className="tw:w-full tw:h-auto tw:object-contain"
        src={previewUrl}
      />
    </div>
  );
}
